import BusinessSettings from './BusinessSettingsContainer';
export default BusinessSettings;
